import axios from "axios";

const API_URL = "https://phone360.net/api/";

class BarcodeService {
  async getBarcodes(ID) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.get(API_URL + "barcodes/" + ID);
    return response.data; // Geri dönen veriyi döndür
  }

  async approved(id,status) {
    const token = localStorage.getItem("user");
    if (token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${
        JSON.parse(token).access_token
      }`;
    }
    const response = await axios.get(API_URL + "transfer/approved?id=" + id+'&status='+status);
    return response.data; // Geri dönen veriyi döndür
  }
}

export default new BarcodeService();
